/* The public header's own list, in its own order. Signing in must not cost a
   player any part of the site — the same map is offered in the player shell,
   folded behind one control so it stays subordinate to the lobby.

   Shared because the shell shows it twice: as its own menu where there is room
   for one, and inside the account menu on a phone, where a fifth control in
   the bar would not fit. */
export const SITE_LINKS = [
  { id: 'home', url: '/' },
  { id: 'about', url: '/faq/what-is-it' },
  { id: 'world', url: '/world' },
  { id: 'community', url: '/community' },
  { id: 'help', url: '/faq' },
  { id: 'roll20', url: '/roll20' },
];
